export enum AccountStatus {
	Active = 'active',
	PendingConsent = 'pending_consent',
}
